<template>
    <div ref="question" class="absolute opacity-[.5]" :class="className">
        <svg xmlns="http://www.w3.org/2000/svg" width="64.946" height="98.976" viewBox="0 0 64.946 98.976">
            <path id="Path_20" data-name="Path 20" d="M-2.56,3.28A11.877,11.877,0,0,1-11.189.152a11.51,11.51,0,0,1-3.227-8.6,11.51,11.51,0,0,1,3.227-8.6A11.877,11.877,0,0,1-2.56-20.176a11.877,11.877,0,0,1,8.629,3.128A11.51,11.51,0,0,1,9.3-8.448,11.51,11.51,0,0,1,6.069.152,11.877,11.877,0,0,1-2.56,3.28Zm0-19.456A7.944,7.944,0,0,0-8.4-14.184a7.592,7.592,0,0,0-2.021,5.736A7.592,7.592,0,0,0-8.4-2.712,7.944,7.944,0,0,0-2.56-.72,7.944,7.944,0,0,0,3.275-2.712,7.592,7.592,0,0,0,5.3-8.448a7.592,7.592,0,0,0-2.021-5.736A7.944,7.944,0,0,0-2.56-16.176ZM7.2-28.208H-11.993l-.23-1.738a29.464,29.464,0,0,1-.025-8.381,17.3,17.3,0,0,1,2.507-6.8A39.392,39.392,0,0,1-1.58-54.289c2.922-2.372,5.735-4.69,8.359-6.891a8.7,8.7,0,0,0,3.253-7.044,7.729,7.729,0,0,0-2.6-6.067C5.641-75.9,2.97-76.72-.512-76.72a13.987,13.987,0,0,0-8.83,2.978,14.36,14.36,0,0,0-3.273,3.526,17.023,17.023,0,0,0-2.1,4.712l-.612,2.164-18.691-7.734.649-1.8a34.941,34.941,0,0,1,4.787-8.96,36.761,36.761,0,0,1,7.274-7.311,30.613,30.613,0,0,1,9.754-4.932A40.923,40.923,0,0,1,.256-95.7a36.649,36.649,0,0,1,12.116,1.968,29.8,29.8,0,0,1,9.736,5.5,25.882,25.882,0,0,1,6.448,8.457,24.754,24.754,0,0,1,2.372,10.784,29.031,29.031,0,0,1-1.04,8.079,18.02,18.02,0,0,1-3.247,6.364A54.675,54.675,0,0,1,18-45.979,90.01,90.01,0,0,0,9.99-38.906c-2.081,2.081-3.021,4.9-2.872,8.618Zm-15.644-4H3.138a14.161,14.161,0,0,1,4.024-9.526,94.022,94.022,0,0,1,8.371-7.39,50.672,50.672,0,0,0,8-7.943c2.252-2.777,3.394-6.789,3.394-11.924a20.788,20.788,0,0,0-1.98-9.056,21.905,21.905,0,0,0-5.456-7.159,25.831,25.831,0,0,0-8.44-4.745A32.664,32.664,0,0,0,.256-91.7,36.942,36.942,0,0,0-10.4-90.245a26.628,26.628,0,0,0-8.486,4.284,32.765,32.765,0,0,0-6.486,6.513,30.688,30.688,0,0,0-3.536,6.161l11.052,4.573a18.759,18.759,0,0,1,6.075-8.2A18.087,18.087,0,0,1-.512-80.72c4.5,0,8.075,1.164,10.62,3.459a11.678,11.678,0,0,1,3.924,9.037A12.645,12.645,0,0,1,9.349-58.116C6.708-55.9,3.879-53.568.94-51.183a35.4,35.4,0,0,0-7.327,8.241C-8.111-40.291-8.8-36.685-8.443-32.208Z" transform="translate(34.018 95.696)" fill="#9180a6" opacity="0.996"/>
        </svg>
    </div>
</template>

<script>
import { gsap } from 'gsap';

    export default {
        name: 'QuestionElement',
        props: {
            className: String,
        },
        mounted () {
            
            document.addEventListener('mousemove', e => {
                if (this.$store.state.quizView || this.$store.state.resultView) return;

                const rect = document.body.getBoundingClientRect();

                const docH = rect.height;
                const docW = rect.width;

                const x = e.pageX - docH;
                const y = e.pageY - docW;

                gsap.to(this.$refs.question, 3, {
                    x: x / gsap.utils.random(30, 50),
                    y: y / gsap.utils.random(30, 50),
                })

            });
        }
    }
</script>